import { connect } from 'react-redux';
import PropertyTypes from './PropertyTypes';
import { fetchPropertyTypeImages } from '../../redux/modules/propertyTypeImages';

const mapStateToProps = ({
  content: {
    propertyTypes,
    siteStaticContent: {
      localizedCountryName
    }
  },
  system: {
    siteName
  },
  propertyTypeImages: { imageUrls }
}) => ({
  propertyTypes,
  siteName,
  destination: localizedCountryName,
  propertyTypeImages: imageUrls
});

const mapDispatchToProps = {
  fetchPropertyTypeImages
};

export default connect(mapStateToProps, mapDispatchToProps)(PropertyTypes);
